import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { isString } from '@trilean/n7';
import { Observable, Subscription } from 'rxjs';
import { map, scan } from 'rxjs/operators';

@Directive({
  selector: '[tr3MqClasses]',
  exportAs: 'tr3MqClasses',
})
export class MediaQueryClassesDirective {
  @Input('tr3MqClasses')
  prefix = 'mq-';

  active: string[] = [];
  activeClasses: string[] = [];
  active$: Observable<string[]>;
  activeClasses$: Observable<string[]>;

  private _subscriptions = new Subscription();

  constructor(private _elementRef: ElementRef, private _renderer: Renderer2, private _mq: MediaObserver) {
    this.active$ = this._mq
      .asObservable()
      .pipe(
        scan(
          (acc, cur) => [
            ...new Set([
              ...acc.filter((v) => this._mq.isActive(v)),
              ...cur.filter((e) => e.matches).map((e) => e.mqAlias),
            ]),
          ],
          new Array<string>(),
        ),
      );
    this.activeClasses$ = this.active$.pipe(map((v) => v.map((e) => (this.prefix ? `${this.prefix}${e}` : e))));
  }

  ngOnInit(): void {
    this._subscriptions.add(this.active$.subscribe((v) => (this.active = v)));
    this._subscriptions.add(this.activeClasses$.subscribe((v) => this.setActiveClasses(v)));
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  isActive(value: string | string[]): boolean {
    return this._mq.isActive(value);
  }

  setActiveClasses(values: string[]): void {
    const removed = this.activeClasses.filter((e) => !values.includes(e));
    this.toggleClass(removed, false);

    const added = values.filter((e) => !this.activeClasses.includes(e));
    this.toggleClass(added, true);

    this.activeClasses = values;
  }

  private toggleClass(value: string | Iterable<string>, enabled: boolean): void {
    const values = isString(value) ? [value] : [...value];
    const el = this._elementRef.nativeElement;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const f = enabled ? (e: any) => this._renderer.addClass(el, e) : (e: any) => this._renderer.removeClass(el, e);
    values.forEach((e) => f(e));
  }
}
